<template>
  <div>
    <div class="outterBox container">
      <b-modal id="errDialog" title="알림" centered ok-title="확인" ok-only>
        <div class="bg-white p-3 rounded box-shadow">
          <p class="text-muted mb-0">
            {{ errDialogMsg1 }}
          </p>
          <p v-if="errDialogMsg2">{{ errDialogMsg2 }}</p>
        </div>
      </b-modal>

      <div class="web">
        <div class="outterBox">
          <div class="topHeader">
            <span class="headerText">프로그램 신청정보</span>
          </div>
          <div class="content">
            <table class="reserv-info table table-borderless">
              <tbody>
                <tr>
                  <td class="tHeader">프로그램명</td>
                  <td colspan="3">
                    <b-form-select v-model="programCode" :options="programOptions"></b-form-select>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">메인</td>
                  <td class="tBody">
                    <b-form-select v-model="mOptionCode" :options="mainOptions"> </b-form-select>
                  </td>
                  <td class="tHeader">추가옵션</td>
                  <td>
                    <b-form-select v-model="sOptionCode" :options="subOptions">
                      <template #first>
                        <b-form-select-option value="">없음</b-form-select-option>
                      </template>
                    </b-form-select>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">희망일자</td>
                  <td>
                    <div class="d-flex">
                      <v-date-picker
                        :min-date="minDate"
                        :max-date="maxDate"
                        v-model="reqDate"
                        :masks="v_datepicker_masks"
                      >
                        <template v-slot="{inputValue, inputEvents}">
                          <b-form-input autocomplete="off" :value="inputValue" v-on="inputEvents" />
                        </template>
                      </v-date-picker>
                      <b-form-select v-model="reqTime" :options="myDateAmPm"></b-form-select>
                    </div>
                  </td>
                  <td class="tHeader">인원수</td>
                  <td>
                    <b-form-select v-model="personCnt" :options="personOptions">
                      <template #first>
                        <b-form-select-option value="0">선택</b-form-select-option>
                      </template>
                    </b-form-select>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">세부요청사항</td>
                  <td colspan="3">
                    <b-form-textarea
                      v-model="reqMemo"
                      placeholder="별도희망일자, 영유아 동반 여부"
                      rows="3"
                      max-rows="6"
                    >
                    </b-form-textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div class="outterBox">
          <div class="topHeader">
            <span class="headerText">프로그램 신청정보</span>
          </div>
          <div class="content">
            <table class="reserv-info table table-borderless">
              <tbody>
                <tr>
                  <td class="tHeader">프로그램명</td>
                  <td>
                    <b-form-select v-model="programCode" :options="programOptions"></b-form-select>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">메인</td>
                  <td>
                    <b-form-select v-model="mOptionCode" :options="mainOptions"> </b-form-select>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">추가옵션</td>
                  <td>
                    <b-form-select v-model="sOptionCode" :options="subOptions">
                      <template #first>
                        <b-form-select-option value="">없음</b-form-select-option>
                      </template>
                    </b-form-select>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">희망일자</td>
                  <td>
                    <div class="d-flex">
                      <v-date-picker
                        :min-date="minDate"
                        :max-date="maxDate"
                        v-model="reqDate"
                        :masks="v_datepicker_masks"
                      >
                        <template v-slot="{inputValue, inputEvents}">
                          <b-form-input autocomplete="off" :value="inputValue" v-on="inputEvents" />
                        </template>
                      </v-date-picker>
                      <b-form-select v-model="reqTime" :options="myDateAmPm"></b-form-select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="tHeader">인원수</td>
                  <td>
                    <b-form-select v-model="personCnt" :options="personOptions">
                      <template #first>
                        <b-form-select-option value="0">선택</b-form-select-option>
                      </template>
                    </b-form-select>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="tHeader">세부요청사항</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <b-form-textarea
                      v-model="reqMemo"
                      placeholder="별도희망일자, 영유아 동반 여부"
                      rows="3"
                      max-rows="6"
                    >
                    </b-form-textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div>
        <ReserveInfo />
      </div>
    </div>
    <div class="buttonGroup">
      <button class="moveButton" @click="nextStage"><span>다음</span></button>
    </div>
  </div>
</template>

<script>
import ReserveInfo from '@/pages/PleisureReservePage/Components/ReserveInfo';
import moment from 'moment';
import reserveService from '@/pages/PleisureReservePage/API/reserve.service';
import GeneralUtil from '@/util/GeneralUtil';
import {PMS_YYYYMMDD} from '@/pages/PleisureReservePage/Model/reserve.model';

export default {
  name: 'ReserveStage1',
  components: {
    ReserveInfo,
  },
  mixins: [GeneralUtil],
  props: {
    useRouteParams: {
      default: false,
    },
    ReserveData: Object,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    isGuestLoggedIn() {
      return this.$store.getters['Auth/isGuestLoggedIn'];
    },
  },
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(),
      errDialogMsg1: '',
      errDialogMsg2: '',
      reqDate: new Date(),
      programCode: '',
      reqTime: 'AM',
      personCnt: 0,
      mOptionCode: '',
      sOptionCode: '',
      reqMemo: '',
      myDateAmPm: [
        {value: 'AM', text: '오전'},
        {value: 'PM', text: '오후'},
      ],
      v_datepicker_masks: {
        input: 'YYYY-MM-DD',
      },
      programOptions: [],
      mainOptions: [],
      subOptions: [],
      personOptions: [],
    };
  },
  watch: {
    programCode(newVal, oldVal) {
      console.log(newVal);
      this.getProgramInfo();
    },
  },
  async created() {
    console.log('this.isLoggedIn:' + this.isLoggedIn);
    console.log('this.isGuestLoggedIn:' + this.isGuestLoggedIn);
    if (!this.isLoggedIn && !this.isGuestLoggedIn) {
      // 로그인 되어 있지 않다면 비회원 로그인 진행한다.
      await this.guestLogin();
    }
    this.programOptions = await this.getProgramList();
    this.programCode = this.ReserveData.programCode;
    this.mOptionCode = this.ReserveData.mOptionCode;
    this.sOptionCode = this.ReserveData.sOptionCode;
    this.reqDate = this.ReserveData.reqDate;
    this.reqTime = this.ReserveData.reqTime;
    this.reqMemo = this.ReserveData.reqMemo;
    this.personCnt = this.ReserveData.personCnt;
    console.log('initProgramCode', this.$route.params.initProgramCode);
    if (this.$route.params.initProgramCode) {
      this.programCode = this.$route.params.initProgramCode;
    }
  },
  methods: {
    async guestLogin() {
      return this.$store.dispatch('Auth/guestLogin');
    },
    isEmptyString(value) {
      if (
        value == '' ||
        value == null ||
        value == undefined ||
        (value != null && typeof value == 'object' && !Object.keys(value).length)
      ) {
        return true;
      } else {
        return false;
      }
    },
    nextStage() {
      //필드 입력체크
      this.ReserveData.programCode = this.programCode;
      this.ReserveData.mOptionCode = this.mOptionCode;
      this.ReserveData.sOptionCode = this.sOptionCode;
      console.log('this.reqDate');
      console.log(this.reqDate);
      let regDateStr = moment(this.reqDate).format(PMS_YYYYMMDD);
      this.ReserveData.reqDate = regDateStr;
      this.ReserveData.reqTime = this.reqTime;
      this.ReserveData.reqMemo = this.reqMemo;
      this.ReserveData.personCnt = this.personCnt;
      console.log(this.ReserveData);
      if (
        this.isEmptyString(this.ReserveData.programCode) ||
        this.isEmptyString(this.ReserveData.mOptionCode) ||
        this.isEmptyString(this.ReserveData.reqTime) ||
        this.ReserveData.personCnt === 0 ||
        this.ReserveData.personCnt === '0'
      ) {
        this.showMsgBoxOk('필수사항을 입력해주세요');
        return;
      }
      this.$emit('nextStage');
    },
    async getProgramInfo() {
      const result = await reserveService.getPrograminfo(this.programCode);
      if (result.resultCode === '0000') {
        const tempMainArr = result.obj.optionList
          .filter(x => x.settingType === 'M')
          .map(a => ({
            value: a.optionCode,
            text: a.viewName,
          }));
        const tempSubArr = result.obj.optionList
          .filter(x => x.settingType === 'S')
          .map(a => ({
            value: a.optionCode,
            text: a.viewName,
          }));
        //메인옵션
        this.mainOptions = tempMainArr;
        //서브옵션
        this.subOptions = tempSubArr;
        //예약가능일 셋팅
        const minDate = moment(result.obj.saleStDate, PMS_YYYYMMDD);
        this.minDate = minDate.toDate();
        const todayDate = moment();
        if (todayDate.isSameOrAfter(minDate)) {
          this.minDate = todayDate.add(7, 'days').toDate();
        }
        const maxDate = moment(result.obj.saleEdDate, PMS_YYYYMMDD);
        this.maxDate = maxDate.toDate();
        this.reqDate = this.minDate;
        //인원수
        let startManCnt = 1;
        let endManCnt = result.obj.personMax;
        let manOptions = [];
        for (let i = startManCnt; i <= endManCnt; i++) {
          const option = {
            value: i,
            text: i + '명',
          };
          manOptions.push(option);
        }
        this.personOptions = manOptions;
      } else {
        this.mainOptions = [];
        this.subOptions = [];
        this.personOptions = [];
        this.minDate = moment().add(7, 'days').toDate();
        this.maxDate = moment().add(8, 'days').toDate();
        this.reqDate = this.minDate;
      }
      //입력값 초기화
      this.mOptionCode = '';
      this.sOptionCode = '';
      this.reqMemo = '';
      this.personCnt = 0;
      this.reqTime = 'AM';
    },
    async getProgramList() {
      let programArr = [];
      const result = await reserveService.getProgramList();
      if (result.resultCode === '0000') {
        const tempArr = result.items.map(a => ({
          value: a.programCode,
          text: a.programName,
        }));
        programArr = programArr.concat(tempArr);
      }
      return programArr;
    },
  },
};
</script>

<style scoped lang="scss">
hr {
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  width: 60%;
}
.outterBox {
}
.topHeader {
  display: flex;
  padding-top: 1rem;
  padding-left: 0rem;

  font-weight: bold;
  font-size: 1.3rem;

  margin-bottom: 1rem;
}
.top {
  display: flex;
  padding: 1rem 1.2rem;
}

th,
td {
  border-bottom: 1px solid #e3e3e3;
  display: table-cell;

  line-height: 2rem;
  vertical-align: middle;
}

.stageContainer {
  display: flex;
}
.stageLeft {
  width: auto;
  margin: 1rem;
  //background-color: red;
}

.stageRight {
  width: 100%;
  //background-color: blue;
  margin: 1rem;
}

.buttonGroup {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  width: 50%;
  .moveButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    width: 100%;
    margin: 1rem;

    background-color: #524a3d !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;
    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }
    &:hover {
      background-color: #403a30 !important;
    }
  }
}
@media (max-width: 992px) {
  .web {
    display: none;
  }

  .mobile {
    display: block;
  }
  .buttonGroup {
    width: 100%;
  }
  .tHeader {
    width: 25%;
    font-size: 0.9rem;
  }
  td {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media (min-width: 992px) {
  .web {
    display: block;
  }

  .mobile {
    display: none;
  }

  .outterBox {
    //background-color: #fafafa;
  }

  .stageContainer {
    //background-color: red;
    display: block;
  }

  .stageLeft {
    margin: 0;
  }

  .stageRight {
    margin: 0;
  }

  .buttonGroup {
    width: 50%;
  }
  .tHeader {
    width: 12%;
    font-size: 1rem;
    font-weight: normal;
    //font-size: 0.9rem;
  }
  .tBody {
    width: 38%;
  }
}
</style>
